import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'spinner-simple',
  templateUrl: './spinner-simple.component.html',
  styleUrls: ['./spinner-simple.component.scss']
})
export class SpinnerSimpleComponent implements OnInit {
  @Input() mensaje:string=''
  dots=''
  constructor() { }

  ngOnInit(): void {
    this.dotes()
  }
  private dotes(){
    setTimeout(()=>{
      if (!this.dots || this.dots.length<3){   this.dots = this.dots + '.'
      } else { this.dots = '' }
      this.dotes()
    },600)
  }
}
